module.exports = __webpack_public_path__ + "media/images/front/icon_04_arrow_y-b34e0deea8ed9a0041e07867601b6eb9.png";